export const lazyLoadModal = function(modalName) {
  return {
    data() {
      return {
        isLazyLoaded: false,
        modalProps: null
      }
    },
    methods: {
      $_lazyLoadModal_onComponentMounted() {
        this.$helper.openModal(modalName, this.modalProps)
      },
      $_lazyLoadModal_onOpenModal(params) {
        this.modalProps = params
        this.$bus.$off(`open-modal-${modalName}`)
        this.isLazyLoaded = true
      }
    },
    mounted() {
      this.$bus.$on(`open-modal-${modalName}`, this.$_lazyLoadModal_onOpenModal)
    },
    beforeDestroy() {
      this.$bus.$off(
        `open-modal-${modalName}`,
        this.$_lazyLoadModal_onOpenModal
      )
    }
  }
}
